import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import { Image } from 'platform/foundation';
import { CellRendererProps } from '../../types/CellRendererProps';
import { getTooltipProps } from '../../utils/getTooltipProps';

// thumbnailHeightPx is pre-computed in GridCell as rowHeightPx - verticalPaddingPx.
// This avoids a per-cell store subscription — the computation lives in GridRow
// (1 subscription per row) and is threaded down via renderCell.
type ThumbnailCellRendererProps = CellRendererProps<string | null> & {
  thumbnailHeightPx: number;
};
export function ThumbnailCellRenderer(props) {
  const $ = _c(11);
  let t0;
  if ($[0] !== props.row) {
    t0 = getTooltipProps(props.row, {});
    $[0] = props.row;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const tooltipProps = t0;
  if (!props.value) {
    return null;
  }
  const imageHeightCss = `calc(${props.thumbnailHeightPx}px)` as const;
  const t1 = `${props.value}&height=500`;
  let t2;
  if ($[2] !== t1) {
    t2 = <Image fit="contain" src={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${props.value}&height=${props.thumbnailHeightPx}`;
  let t4;
  if ($[4] !== imageHeightCss || $[5] !== t3) {
    t4 = <Image fit="contain" height={imageHeightCss} src={t3} />;
    $[4] = imageHeightCss;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4 || $[9] !== tooltipProps) {
    t5 = <div className="flex items-center [&_img]:rounded"><Tooltip {...tooltipProps} isDisabled={false} label={t2}>{t4}</Tooltip></div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = tooltipProps;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}